var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-conversation-answer-colorselector",class:_vm.className},[_c('section',{staticClass:"color-gradient"},[_c('section',{staticClass:"color-stack",on:{"click":_vm.Handle_OnClickColorStack}},_vm._l((_vm.hexColors),function(color,index){return _c('div',{key:index,staticClass:"color-swatch",style:({ backgroundColor: color })})}),0),_c('div',{staticClass:"indicator",style:({
				left: _vm.value * 95 + '%',
			})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }